import { pageLocale } from "./locale";

//This constant is used in pdfHistory
const {
  tug_time,
  gait_score,
  speed,
  balance_score,
  step_length,
  steps_per_minute,
  head_wobbling,
  shoulder_balance,
  hip_balance,
  sit_to_standup_time,
  attempts_to_rise,
  good_cap,
  average_cap,
  poor_cap,
  good,
  average,
  poor,
  s,
  steps_min,
  degree,
} = pageLocale("newreport");
export const pdfGraph = {
  tugTime: {
    chartTitle: tug_time,
    range: [
      {
        status: good_cap,
        text: "< 12",
      },
      {
        status: average_cap,
        text: "12 ~ 14",
      },
      {
        status: poor_cap,
        text: "> 14",
      },
    ],
    rangeImg: [
      { cond: "X < 12", type: good },
      { cond: "12 <= X && X <= 14", type: average },
      { cond: "X > 14", type: poor },
    ],
    yAxis: [0, 10, 20, 30, 40],
    green: 12,
    red: 14,
    unit: s,
  },
  gaitScore: {
    chartTitle: gait_score,
    range: [
      {
        status: good_cap,
        text: "> 4",
      },
      {
        status: average_cap,
        text: "2 ~ 4",
      },
      {
        status: poor_cap,
        text: "< 2",
      },
    ],
    rangeImg: [
      { cond: "X < 2", type: poor },
      { cond: "2 <= X && X <= 4", type: average },
      { cond: "4 < X", type: good },
    ],
    yAxis: [0, 2, 4, 6],
    green: 4,
    red: 2,
    unit: "",
  },
  stepLength: {
    chartTitle: step_length,
    range: [
      {
        status: good_cap,
        text: ">= 50",
      },
      {
        status: average_cap,
        text: "41 ~ 49",
      },
      {
        status: poor_cap,
        text: "<= 40",
      },
    ],
    rangeImg: [
      { cond: "X >= 50", minMax: [50, 100], type: good },
      { cond: "40 < X && X < 50", minMax: [40, 50], type: average },
      { cond: "40 >= X", minMax: [0, 40], type: poor },
    ],
    yAxis: [0, 50, 100, 150, 200],
    green: 50,
    red: 40,
    unit: "(cm)",
  },
  stepsPerMin: {
    chartTitle: steps_per_minute,
    range: [
      {
        status: good_cap,
        text: ">= 50",
      },
      {
        status: average_cap,
        text: "41 ~ 49",
      },
      {
        status: poor_cap,
        text: "<= 40",
      },
    ],
    rangeImg: [
      { cond: "X <= 40", minMax: [0, 40], type: poor },
      { cond: "40 < X && X < 50", minMax: [40, 50], type: average },
      { cond: "50 <= X", minMax: [50, 100], type: good },
    ],
    yAxis: [0, 50, 100, 150, 200],
    green: 50,
    red: 50,
    unit: `(${steps_min})`,
  },
  balanceScore: {
    chartTitle: balance_score,
    range: [
      {
        status: good_cap,
        text: " >= 4",
      },
      {
        status: average_cap,
        text: "2 ~ 3",
      },
      {
        status: poor_cap,
        text: "<2",
      },
    ],
    rangeImg: [
      { cond: "X < 2", type: poor },
      { cond: "2 <= X && X < 4", type: average },
      { cond: "4 <= X", type: good },
    ],
    yAxis: [0, 2, 4, 6, 8],
    green: 4,
    red: 1,
    unit: "",
  },
  headWobble: {
    chartTitle: head_wobbling,
    range: [
      {
        status: good_cap,
        text: "<= 1.5",
      },
      {
        status: poor_cap,
        text: "> 1.5",
      },
    ],
    rangeImg: [
      { cond: "X <= 1.5", minMax: [0, 1.5], type: good },
      { cond: "1.5 <= X", minMax: [1.5, 3], type: poor },
    ],
    yAxis: [0, 1, 2, 3, 4],
    green: 1.5,
    red: 1.5,
    unit: "(cm)",
  },
  shoulderTheta: {
    chartTitle: shoulder_balance,
    range: [
      {
        status: good_cap,
        text: "Θ <= 2°",
      },
      {
        status: average_cap,
        text: "2°<Θ<=5°",
      },
      {
        status: poor_cap,
        text: " Θ > 5°",
      },
    ],
    rangeImg: [
      { cond: "X <= 2", minMax: [0, 2], type: good },
      { cond: "2 < X && X <= 5", minMax: [2, 5], type: average },
      { cond: "5 < X", minMax: [5, 10], type: poor },
    ],
    yAxis: null,
    green: "",
    red: "",
    unit: `(${degree} θ)`,
  },
  hipTheta: {
    chartTitle: hip_balance,
    range: [
      {
        status: good_cap,
        text: "Θ <= 2°",
      },
      {
        status: average_cap,
        text: "2°<Θ<=5°",
      },
      {
        status: poor_cap,
        text: " Θ > 5°",
      },
    ],
    rangeImg: [
      { cond: "X <= 2", minMax: [0, 2], type: good },
      { cond: "2 < X && X <= 5", minMax: [2, 5], type: average },
      { cond: "5 < X", minMax: [5, 10], type: poor },
    ],
    yAxis: null,
    green: "",
    red: "",
    unit: `(${degree} θ)`,
  },
  speed: {
    chartTitle: speed,
    range: [
      {
        status: good_cap,
        text: ">= 50",
      },
      {
        status: average_cap,
        text: "41 ~ 49",
      },
      {
        status: poor_cap,
        text: "<= 40",
      },
    ],
    rangeImg: [
      { cond: "X <= 40", minMax: [0, 40], type: poor },
      { cond: "40 < X && X < 50", minMax: [40, 50], type: average },
      { cond: "50 <= X", minMax: [50, 100], type: good },
    ],
    yAxis: [0, 50, 100, 150, 200],
    green: "50",
    red: "40",
    unit: "(cm/s)",
  },
  timeToStandUp: {
    chartTitle: sit_to_standup_time,
    range: [
      {
        status: good_cap,
        text: ">4",
      },
      {
        status: average_cap,
        text: "2 ~ 3",
      },
      {
        status: poor_cap,
        text: "0 ~ 1",
      },
    ],
    rangeImg: [
      { cond: "X >= 4", minMax: [4, 6], type: good },
      { cond: "2 <= X && X < 4", minMax: [2, 4], type: average },
      { cond: "X < 2", minMax: [0, 2], type: poor },
    ],
    yAxis: [0, 2, 4, 6, 8],
    green: "1",
    red: "0",
    unit: s,
  },
  attemptsToRise: {
    chartTitle: attempts_to_rise,
    range: [
      {
        status: good_cap,
        text: "2",
      },
      {
        status: average_cap,
        text: "1",
      },
      {
        status: poor_cap,
        text: "0",
      },
    ],
    rangeImg: [
      { cond: "X == 2", minMax: [2, 4], type: good },
      { cond: "X == 1", minMax: [1, 2], type: average },
      { cond: "X == 0", minMax: [0, 1], type: poor },
    ],
    yAxis: [0, 2, 4, 6, 8],
    green: "1",
    red: "0",
    unit: "",
  },
  sidebalanceScore: {
    chartTitle: balance_score,
    range: [
      {
        status: good_cap,
        text: "4",
      },
      {
        status: average_cap,
        text: "2 ~ 3",
      },
      {
        status: poor_cap,
        text: "<= 1",
      },
    ],
    rangeImg: [
      { cond: "X < 2", type: poor },
      { cond: "2 <= X && X < 4", type: average },
      { cond: "4 <= X", type: good },
    ],
    yAxis: [0, 2, 4, 6],
    green: 4,
    red: 1,
    unit: "",
  },
};

//this constant fro showing the range of the test in history page
export const forHistoryScoreShow = {
  fronttugTime: {
    chartTitle: tug_time,
    range: [
      {
        status: good_cap,
        text: "< 12",
      },
      {
        status: average_cap,
        text: "12 ~ 14",
      },
      {
        status: poor_cap,
        text: "> 14",
      },
    ],
  },
  frontgaitSummary: {
    chartTitle: gait_score,
    range: [
      {
        status: good_cap,
        text: "> 4",
      },
      {
        status: average_cap,
        text: "2 ~ 4",
      },
      {
        status: poor_cap,
        text: "< 2",
      },
    ],
  },
  frontgaitSpeed: {
    chartTitle: speed,
    range: [
      {
        status: good_cap,
        text: ">= 50",
      },
      {
        status: average_cap,
        text: "41 ~ 49",
      },
      {
        status: poor_cap,
        text: "<= 40",
      },
    ],
  },
  frontgaitStepLength: {
    chartTitle: step_length,
    range: [
      {
        status: good_cap,
        text: ">= 50",
      },
      {
        status: average_cap,
        text: "41 ~ 49",
      },
      {
        status: poor_cap,
        text: "<= 40",
      },
    ],
  },
  frontgaitStepPerMinute: {
    chartTitle: steps_per_minute,
    range: [
      {
        status: good_cap,
        text: ">= 50",
      },
      {
        status: average_cap,
        text: "41 ~ 49",
      },
      {
        status: poor_cap,
        text: "<= 40",
      },
    ],
  },
  frontBalancesummary: {
    chartTitle: balance_score,
    range: [
      {
        status: good_cap,
        text: ">= 4",
      },
      {
        status: average_cap,
        text: "2 ~ 3",
      },
      {
        status: poor_cap,
        text: " <2",
      },
    ],
  },
  sideBalancesummary: {
    chartTitle: balance_score,
    range: [
      {
        status: good_cap,
        text: "4",
      },
      {
        status: average_cap,
        text: "2 ~ 3",
      },
      {
        status: poor_cap,
        text: "<= 1",
      },
    ],
  },
  frontbalanceHeadWobbling: {
    chartTitle: head_wobbling,
    range: [
      {
        status: good_cap,
        text: "<= 1.5",
      },
      {
        status: poor_cap,
        text: "> 1.5",
      },
    ],
    unit: "(cm)",
  },
  frontShoulderBalance: {
    chartTitle: shoulder_balance,
    range: [
      {
        status: good_cap,
        text: "Θ <= 2°",
      },
      {
        status: average_cap,
        text: "2° < Θ <= 5°",
      },
      {
        status: poor_cap,
        text: " Θ > 5°",
      },
    ],
  },
  frontHipBalance: {
    chartTitle: hip_balance,
    range: [
      {
        status: good_cap,
        text: "Θ <= 2°",
      },
      {
        status: average_cap,
        text: "2° < Θ <= 5°",
      },
      {
        status: poor_cap,
        text: " Θ > 5°",
      },
    ],
  },
  timeToStandUp: {
    chartTitle: sit_to_standup_time,
    range: null,
  },
  attemptsToRise: {
    chartTitle: attempts_to_rise,
    range: [
      {
        status: good_cap,
        text: "2",
      },
      {
        status: average_cap,
        text: "1",
      },
      {
        status: poor_cap,
        text: "0",
      },
    ],
  },
};
